import EventsAPI from "~/services/events";
import useUserStore from "~/stores/user";
import getErrorLocalePathMessage from "~/utils/locale";

export default function useEventSelect(eventId: string) {
  const loading = ref(false);
  const { t, te } = useI18n();
  const userStore = useUserStore();
  const isSelected = computed(() => Boolean(userStore.selected[eventId]));
  const toaster = useToast();
  const onError = (error: Error) => {
    const { message } = getErrorLocalePathMessage(error.message, { t, te });
    return toaster.error(message);
  };

  async function toggleEventSelect() {
    loading.value = true;

    if (isSelected.value)
      await EventsAPI.selected.unselectVideo(eventId).catch(onError);
    else
      await EventsAPI.selected.selectVideo(eventId).catch(onError);

    loading.value = false;
  }

  return { isSelected, loading, toggleEventSelect };
}
